import { z } from 'zod';
import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi';
// Extend Zod with OpenAPI
extendZodWithOpenApi(z);
const uuidSchema = z.string().uuid();
export const UserActivitySchema = z
    .object({
    id: uuidSchema.openapi({
        description: 'Unique identifier for the activity record',
        example: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
    }),
    userId: uuidSchema.openapi({
        description: 'ID of the user who performed the activity',
        example: 'b2c3d4e5-f6a7-8901-bcde-f12345678901',
    }),
    activityType: z.string().openapi({
        description: 'Type of activity performed (e.g. course_created, lesson_completed, user_login)',
        example: 'course_created',
    }),
    description: z.string().openapi({
        description: 'Human-readable description of the activity',
        example: 'Created course "Introduction to React"',
    }),
    entityType: z.string().openapi({
        description: 'Type of entity the activity relates to (e.g. course, module, lesson, step, user)',
        example: 'course',
    }),
    entityId: uuidSchema.openapi({
        description: 'ID of the entity the activity relates to',
        example: 'c3d4e5f6-a7b8-9012-cdef-123456789012',
    }),
    createdAt: z.string().openapi({
        description: 'Timestamp when the activity was recorded',
        example: '2026-02-27T10:30:00.000Z',
    }),
})
    .openapi('UserActivity');
export const ListActivitiesQuerySchema = z
    .object({
    page: z
        .string()
        .optional()
        .default('1')
        .transform((val) => parseInt(val, 10))
        .refine((val) => val > 0, 'Page must be greater than 0')
        .openapi({
        description: 'Page number for pagination (1-based)',
        example: '1',
    }),
    pageSize: z
        .string()
        .optional()
        .default('20')
        .transform((val) => parseInt(val, 10))
        .refine((val) => val > 0 && val <= 100, 'Page size must be between 1 and 100')
        .openapi({
        description: 'Number of activity records per page (1-100)',
        example: '20',
    }),
})
    .openapi('ListActivitiesQuery');
//# sourceMappingURL=activity.schema.js.map